import { render } from "./LoziLogo.vue?vue&type=template&id=339cdee0"
import script from "./LoziLogo.vue?vue&type=script&lang=ts"
export * from "./LoziLogo.vue?vue&type=script&lang=ts"
script.render = render

export default script